import { useState, useContext } from "react";
import { Flow } from "./audit/Flow";
import { Table } from "./audit/Table";
import { StoreContext } from "../store/Store";
import {Screenshot} from "./audit/ScreenShot"

export const Audit = () => {
  const [store] = useContext(StoreContext);
  const [layout, setLayout] = useState("table");
  const { audit_flowSelection } = store;
  return audit_flowSelection === "Audit" ? (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{  display:"flex",justifyContent:"center",gap:40 ,paddingTop:10}}>
        <label>
          flow
          <input
            type="radio"
            checked={layout === "flow"}
            name="radio"
            onChange={() => setLayout("flow")}
          />
        </label>
        <label>
          table
          <input
            type="radio"
            checked={layout === "table"}
            name="radio"
            onChange={() => setLayout("table")}
          />
        </label>
      </div>
      <div style={{ flexGrow: 1 }}>
        <Screenshot/>
        {layout === "table" ? <Table /> : <Flow />}
      </div>
    </div>
  ) : null;
};
